/* Al Fagr - own quick view (eye button on cards) */
(function () {
  'use strict';
  if (window.__fgQV) return; window.__fgQV = 1;
  var D = document, modal = null;
  var $ = function (s, r) { return (r || D).querySelector(s); };

  function close() {
    if (!modal) return;
    modal.parentNode.removeChild(modal); modal = null;
    D.documentElement.classList.remove('fg-qv-lock');
  }
  function open(card) {
    var F = window.FagrShop; if (!F) return;
    var P = F.getData(card); if (!P) return;
    close();
    var st = { color: F.firstColor(P), size: null };
    var cur = 0;
    modal = D.createElement('div'); modal.className = 'fg-qv'; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
    var thumbs = P.img.map(function (im, i) { return '<button type="button" class="fg-qv__th' + (i ? '' : ' is-on') + '" data-qv-i="' + i + '"><img src="' + F.esc(im.s) + '" alt="" loading="lazy"></button>'; }).join('');
    modal.innerHTML = '<div class="fg-qv__bg" data-qv-x></div><div class="fg-qv__box"><button type="button" class="fg-qv__x" data-qv-x aria-label="Close">×</button>' +
      '<div class="fg-qv__gal"><div class="fg-qv__main"><img data-qv-main alt="' + F.esc(P.t) + '" src="' + F.esc((P.img[0] && P.img[0].s) || '') + '"><button type="button" class="fg-qv__ar fg-qv__ar--p" data-qv-n="-1" aria-label="Prev">‹</button><button type="button" class="fg-qv__ar fg-qv__ar--n" data-qv-n="1" aria-label="Next">›</button></div><div class="fg-qv__ths">' + thumbs + '</div></div>' +
      '<div class="fg-qv__info"><h3>' + F.esc(P.t) + '</h3><div class="fg-qv__pr" data-qv-price></div><div data-qv-pick></div>' +
      '<button type="button" class="fg-qv__atc" data-qv-atc><span>' + F.T('Add to cart', 'أضف للسلة') + '</span></button>' +
      '<a class="fg-qv__more" href="' + F.esc(P.u) + '">' + F.T('View full details', 'عرض كل التفاصيل') + ' →</a></div></div>';
    D.body.appendChild(modal); D.documentElement.classList.add('fg-qv-lock');
    var main = $('[data-qv-main]', modal), ths = modal.querySelectorAll('.fg-qv__th');
    function show(i) {
      if (!P.img.length) return;
      cur = (i + P.img.length) % P.img.length; main.src = P.img[cur].s;
      Array.prototype.forEach.call(ths, function (t, k) { t.classList.toggle('is-on', k === cur); });
    }
    var pk = F.Picker(P, st, function (kind) {
      if (kind === 'color') { var id = F.imgOfColor(P, st.color); if (id) { for (var k = 0; k < P.img.length; k++) if (P.img[k].i === id) { show(k); break; } } }
      sync();
    });
    $('[data-qv-pick]', modal).appendChild(pk.el);
    var atc = $('[data-qv-atc]', modal);
    function sync() {
      var v = pk.variant(), pr = $('[data-qv-price]', modal);
      if (!v) return;
      pr.innerHTML = '<b>' + F.money(v.p) + '</b>' + (v.c > v.p ? '<s>' + F.money(v.c) + '</s>' : '');
      atc.disabled = !v.a; $('span', atc).textContent = v.a ? F.T('Add to cart', 'أضف للسلة') : F.T('Sold out', 'نفدت الكمية');
    }
    atc.addEventListener('click', function () {
      var v = pk.variant(); if (!v || !v.a) return; atc.disabled = true;
      F.Cart.add([{ id: v.id, quantity: 1 }]).then(function () { close(); }).catch(function (e) {
        atc.disabled = false; $('span', atc).textContent = (e && e.message) || F.T('Error', 'خطأ');
      });
    });
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-qv-x]')) { close(); return; }
      var t = e.target.closest('[data-qv-i]'); if (t) { show(+t.getAttribute('data-qv-i')); return; }
      var n = e.target.closest('[data-qv-n]'); if (n) show(cur + (+n.getAttribute('data-qv-n')));
    });
    var id0 = F.imgOfColor(P, st.color); if (id0) { for (var k = 0; k < P.img.length; k++) if (P.img[k].i === id0) { show(k); break; } }
    sync();
  }
  D.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fg-qv]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var card = b.closest('[data-fg-card]'); if (card) open(card);
  }, true);
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
